import { createAction, props } from '@ngrx/store';
import { Tag, TagsListMeta, TagSubmitPayload } from '../models/tag.model';
import { ApiTableFilter } from '../../../shared/models/table-filter.model';

export const loadTags = createAction(
  '[Tags] Load Tags',
  props<{
    page?: number;
    perPage?: number;
    search?: string;
    sort?: string;
    sortDirection?: string;
    filters?: ApiTableFilter[];
    filterLink?: string;
  }>()
);
export const loadTagsSuccess = createAction(
  '[Tags] Load Tags Success',
  props<{ tags: Tag[]; meta: TagsListMeta }>()
);
export const loadTagsFailure = createAction(
  '[Tags] Load Tags Failure',
  props<{ error: string }>()
);

export const submitTag = createAction(
  '[Tags] Submit Tag',
  props<{ payload: TagSubmitPayload; isEditMode: boolean }>()
);
export const submitTagSuccess = createAction('[Tags] Submit Tag Success');
export const submitTagFailure = createAction(
  '[Tags] Submit Tag Failure',
  props<{ error: string }>()
);

export const deleteTag = createAction(
  '[Tags] Delete Tag',
  props<{ tagId: string }>()
);
export const deleteTagSuccess = createAction('[Tags] Delete Tag Success');
export const deleteTagFailure = createAction(
  '[Tags] Delete Tag Failure',
  props<{ error: string }>()
);

export const resetTagsState = createAction('[Tags] Reset State');
